// This file was automatically generated from uiwidget.Dipdown.html.
// Please don't edit this file by hand.

goog.provide('el8.template.uiwidget.Dipdown');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.uiwidget.Dipdown.container = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="dropdown-container ', soy.$$escapeHtml(opt_data.containerClass), '"><a class="dropdown-close-trigger el8DialogCloseButton"></a>', (opt_data.hasTitle) ? '<div class="dropdown-title ' + soy.$$escapeHtml(opt_data.titleClass) + '"></div>' : '', '<div class="dropdown-content el8DipdownContent"></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.uiwidget.Dipdown.tail = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="dropdown-tail-holder"><span class="', soy.$$escapeHtml(opt_data.tailClass), 'Body dropdown-tail-body"></span><span class="', soy.$$escapeHtml(opt_data.tailClass), 'Border dropdown-tail-border"></span></div>');
  if (!opt_sb) return output.toString();
};
